<template>
    <form class="m-t" role="form" @submit.prevent="onSubmit">
        <div class="form-group">
            <label for="billingCompany">Company Name <span class="text-danger">*</span></label>
            <input type="text" id="billingCompany" class="form-control" :class="formControl('billing_company')" placeholder="Company" v-model="formData.billing_company" autofocus required>
            <small class="form-text text-danger text-red" v-html="formValidation.billing_company"></small>
        </div>

        <hr />

        <div class="form-group">
            <label for="desiredUsername">Desired Username <span class="text-danger">*</span></label>
            <input type="text"
                id="desiredUsername"
                :class="formControl('user')"
                placeholder="Username"
                v-model="formData.user"
                pattern="[a-zA-Z0-9]{3,20}"
                title="username must be alphanumeric and 3 to 20 characters in length"
                required
            >
            <small class="form-text text-danger text-red" v-html="formValidation.user"></small>
        </div>
        <div class="form-group">
            <label for="email">E-Mail <span class="text-danger">*</span></label>
            <input
                type="email"
                id="email"
                class="form-control"
                placeholder="Email"
                v-model="formData.email"
                autocomplete="username"
                required
            >
            <small class="form-text text-danger text-red" v-html="formValidation.email"></small>
        </div>
        <div class="form-group">
            <label for="password">Password <span class="text-danger">*</span></label>
            <div style="position: relative;">
                <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    data-indicator="pwindicator"
                    id="password"
                    placeholder="Password"
                    pattern="(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}"
                    title="Password must contain at least one digit, one lowercase, one uppercase, and be between 8 and 32 characters"
                    v-model="formData.pw1"
                    autocomplete="new-password"
                    required
                    style="padding-right: 40px;"
                />
                <button
                    type="button"
                    @click="showPassword = !showPassword"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); border: none; background: transparent; cursor: pointer; color: #666;"
                    :title="showPassword ? 'Hide password' : 'Show password'"
                >
                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
            </div>
            <small class="form-text text-danger text-red" v-html="formValidation.pw1"></small>
            <div id="pwindicator">
                <div class="bar"></div>
                <div class="label"></div>
            </div>
        </div>
        <div class="form-group">
            <label for="confirmpw">Confirm Password <span class="text-danger">*</span></label>
            <div style="position: relative;">
                <input
                    id="confirmpw"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    class="form-control"
                    placeholder="Confirm Password"
                    v-model="formData.pw2"
                    autocomplete="new-password"
                    required
                    style="padding-right: 40px;"
                />
                <button
                    type="button"
                    @click="showConfirmPassword = !showConfirmPassword"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); border: none; background: transparent; cursor: pointer; color: #666;"
                    :title="showConfirmPassword ? 'Hide password' : 'Show password'"
                >
                    <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
            </div>
            <small class="form-text text-danger text-red" v-html="formValidation.pw2"></small>
        </div>

        <hr />

        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="firstName">First Name <span class="text-danger">*</span></label>
                <input id="firstName" type="text" class="form-control" v-model="formData.first" placeholder="First" required>
            </div>
            <div class="form-group col-md-6">
                <label for="lastName">Last Name <span class="text-danger">*</span></label>
                <input id="lastName" type="text" class="form-control" v-model="formData.last" placeholder="Last" required>
            </div>
        </div>
        <div class="form-group">
            <label for="title">Title <span class="text-danger">*</span></label>
            <input id="title" type="text" class="form-control" v-model="formData.title" placeholder="Title" required>
        </div>
        <div class="form-row">
            <!-- Office Phone with Mask -->
            <div class="form-group col-md-7">
                <label for="officePhone">Office Phone Number <span class="text-danger">*</span></label>
                <MaskInput
                    id="officePhone"
                    class="form-control"
                    :class="formControl('officephone')"
                    v-model="formData.officephone"
                    mask="(###) ###-####"
                    placeholder="Office #"
                    required
                />
                <small class="form-text text-danger text-red" v-html="formValidation.officephone"></small>
            </div>

            <!-- Office Extension -->
            <div class="form-group col-md-5">
                <label for="officeExt">Office Extension</label>
                <input
                    id="officeExt"
                    type="text"
                    class="form-control"
                    :class="formControl('officeext')"
                    v-model="formData.officeext"
                    placeholder="Office Ext"
                />
                <small class="form-text text-danger text-red" v-html="formValidation.officeext"></small>
            </div>

            <!-- Hidden User Profile Field -->
            <div id="userProfile" class="form-group d-n">
                <input
                    type="text"
                    class="form-control d-n"
                    v-model="formData.user_profile"
                    placeholder="User Profile"
                    tabindex="-1"
                    autocomplete="off"
                />
            </div>
        </div>

        <!-- Mobile Phone with Mask -->
        <div class="form-group">
            <label for="mobilePhone">Mobile Phone Number <span class="text-danger">*</span></label>
            <MaskInput
                id="mobilePhone"
                class="form-control"
                :class="formControl('mobilephone')"
                v-model="formData.mobilephone"
                mask="(###) ###-####"
                placeholder="Mobile #"
                required
            />
            <small class="form-text text-danger text-red" v-html="formValidation.mobilephone"></small>
        </div>


        <hr>

        <div class="form-group">
            <label for="registrationCode">Registration Code <span class="text-danger">*</span></label>
            <input id="registrationCode" type="text" :class="formControl('regcode')" placeholder="Registration Code" v-model="formData.regcode" title="enter the code provided to you by a RadSite Administrator or contact RadSite for your registration code" required>
            <small class="form-text text-danger text-red" v-html="formValidation.regcode"></small>
            <small class="form-text text-muted">
                Enter the code provided to you by a RadSite Administrator or <a href="https://radsitequality.com/contact/" target="_blank">contact RadSite</a> for your registration code.
            </small>
        </div>

        <hr />

        <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" name="toc" id="TocCheckbox" required>
              <label class="form-check-label ml-05" for="TocCheckbox">I have read and agree to the </label>
              <a :href="termsURL" target="_blank"> Terms and Conditions</a>
            </div>
        </div>

        <button 
            type="submit" 
            class="btn btn-primary btn-rsq btn-round block full-width m-b" 
            id="register-submit" 
            :class="{ '-disabled': isSubmitting }" 
            :disabled="isSubmitting"
        >
            <span v-if="isSubmitting"><i class="fas fa-spinner fa-spin"></i> Registering...</span>
            <span v-else>Register</span>
        </button>

    </form>
</template>
<script>
    export default {
        props: ['nonce'],
        data() {
            return {
                isSubmitting: false,
                formErrors: [],
                showPassword: false,
                showConfirmPassword: false,
                formData: {
                    billing_company: '',
                    user: '',
                    email: '',
                    pw1: '',
                    pw2: '',
                    first: '',
                    last: '',
                    title: '',
                    officephone: '',
                    officeext: '',
                    mobilephone: '',
                    user_profile: '',
                    regcode: '',
                    nonce: ''
                },
                formValidation: {
                    billing_company: '',
                    user: '',
                    email: '',
                    pw1: '',
                    pw2: '',
                    first: '',
                    last: '',
                    title: '',
                    officephone: '',
                    officeext: '',
                    mobilephone: '',
                    user_profile: '',
                    regcode: ''
                }
            }
        },
        mounted() {
            this.pwStrength();
            this.formData.nonce = this.nonce;
        },
        methods: {
            onSubmit() {
                this.formValidation = { billing_company: '', user: '', email: '', pw1: '', pw2: '', first: '', last: '', title: '', officephone: '', officeext: '', mobilephone: '', user_profile: '', regcode: '' };

                if( this.validate() ) {
                    this.isSubmitting = true;

                    $.ajax({
                        url: localized.ajaxurl + 'action_rrsp_register',
                        method: 'POST',
                        data: this.formData,
                        dataType: 'json',
                        success: (result) => {
                            if(result.success) {
                                window.location = localized.homeurl + '/client-panel';
                            } else {
                                this.handleErrors(result.errors);
                            }
                        },
                        error: function(result) {
                            toastr.error(result, 'Error');
                        },
                        complete: () => {
                            this.isSubmitting = false;
                        }
                    });
                }
            },
            validate() {
                if( this.formData.pw1.localeCompare(this.formData.pw2) != 0 ) {
                    this.formValidation.pw1 = 'Passwords do not match';
                    this.formValidation.pw2 = 'Passwords do not match';
                    return false;
                }

                return true;
            },
            rectifyPassword() {
                if( this.formData.pw1.localeCompare(this.formData.pw2) == 0 ) {
                    this.formValidation.pw1 = '';
                    this.formValidation.pw2 = '';
                    return false;
                }
            },
            handleErrors(errors) {
                _.forEach( errors, (message, errcode) => {
                    this.formValidation[errcode] = message;
                } )
            },
            pwStrength() {
                var options = {};
                options.ui = {
                    bootstrap4: true,
                    showVerdictsInsideProgressBar: true
                };
                options.common = {
                    onScore: function (options, word, totalScoreCalculated) {
                            let strongPatt = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$");
                            let strongRes = strongPatt.test(word);

                            if(strongRes && word.length > 12)
                                return options.ui.scores[4];

                            if(strongRes)
                                return options.ui.scores[3];

                            // Fall back to the score that was calculated by the rules engine.
                            // Must pass back the score to set the total score variable.
                            return totalScoreCalculated;
                        }
                }

                $('#password').pwstrength(options);
            },
            formControl(field) {
                let classes = ['form-control'];

                if( this.formValidation[field] != '' )
                    classes.push('is-invalid');

                return classes;
            }
        },
        computed: {
            termsURL() {
                return 'https://radsiteportal.com/terms-conditions';
            }
        }
    }
</script>
